module.exports = __webpack_public_path__ + "media/images/web/landings/students/s3-0af524533b57c32d25bfbaf343b48a6e.jpg";